import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

/**
 * Standardized race/event selector dropdown.
 * @param {{
 *   races: Array<{id: string|number, name: string, startDate?: string}>,
 *   value: string,
 *   onChange: (value: string) => void,
 *   label?: string,
 *   placeholder?: string,
 *   showDate?: boolean,
 *   className?: string,
 * }} props
 */
export default function RaceSelector({
  races,
  value,
  onChange,
  label = '',
  placeholder = 'Избери настан...',
  showDate = false,
  className = '',
}) {
  return (
    <div className={className}>
      {label && (
        <Label className="mb-2 block text-sm font-medium">{label}</Label>
      )}
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {races.map((race) => (
            <SelectItem key={race.id} value={String(race.id)}>
              {race.name}
              {showDate && race.startDate && ` — ${new Date(race.startDate).toLocaleDateString()}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
